import React from 'react'
import { connect } from 'react-redux'
import { ErrorIcon } from '../../assets/icons'
import { clearFlashMessage } from '../../actions'
import Modal from '../Modal'
import { Text1 } from '../../styled/generics'
import { Button } from './button'
import SuccessIcon from '../../assets/icons/success'

const ApiErrorMessage = props =>
	props.flashMessage.message ? (
		<Modal
			withComponentContainer
			componentContainerProps={{
				$alignItems: 'center',
				$padding: '20px',
				$paddingDesktop: '20px',
				$gap: '24px'
			}}
		>
				{props.flashMessage.success ? <SuccessIcon size={72}/> : <ErrorIcon />}
				<Text1>{props.flashMessage.message}</Text1>
				<Button label="Cerrar" $variant="primary" onClick={props.clearFlashMessage} />
		</Modal>
	) : null

const mapDispatchToProps = { clearFlashMessage }
function mapStateToProps({ flashMessage }) {
	return { flashMessage }
}
export default connect(mapStateToProps, mapDispatchToProps)(ApiErrorMessage)
